import { a as t } from "./lit-element-6iugfgmM.js";
/**
 * @license
 * Copyright 2018 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
const r = (o) => o ?? t;
export {
  r as o
};
//# sourceMappingURL=if-defined-D-RhGngI.js.map
